import type { CardLens, LensDisplay } from '~/types/leLens';

/** Explicit choices override presentation defaults; retain existing custom-view preferences. */
export function lensDisplayPreferences(spec: CardLens['spec']): Required<LensDisplay> {
  return {
    compactLayout: spec.display?.compactLayout ?? spec.customView?.compactLayout ?? Boolean(spec.customView),
    showTitle: spec.display?.showTitle ?? spec.customView?.showTitle ?? !spec.customView,
  };
}

/** Editing always exposes the full board controls without changing reader preferences. */
export function lensDisplay(spec: CardLens['spec'], editing = false) {
  if (editing) return { minimalChrome: false, showTitle: true };
  const preferences = lensDisplayPreferences(spec);
  return { minimalChrome: preferences.compactLayout, showTitle: preferences.showTitle };
}
